import BaseTableNew from 'components/atoms/base-table/new';

import { useParentCols } from './cols/parentColumns';
import s from './styles.module.scss';

import type { Clinic } from 'infrastructure/classes/clinic';
import type { MergedMeta } from 'infrastructure/hooks/clinic/use-admin-clinic-list';
import type { IClinicListFilters } from 'infrastructure/interfaces';

interface IProps {
  loading: boolean;
  meta: MergedMeta;
  clinics: Clinic[];
  filters: IClinicListFilters;
  onChangePage: (page: number) => void;
}

export default function ParentViewTable({
  meta,
  filters,
  clinics,
  loading,
  onChangePage,
}: IProps) {
  const parentColumns = useParentCols();

  return (
    <BaseTableNew
      rowKey="guid"
      rowClassName={s['table-row']}
      bordered
      dataCy="clinics-parent-table"
      items={clinics}
      columns={parentColumns ?? []}
      loading={loading}
      pagination={{
        current: filters.page ?? 1,
        pageSize: meta.items,
        total: meta.totalCount,
        position: ['bottomCenter'],
      }}
      onChangePage={onChangePage}
      anchor
    />
  );
}
